import resolveConfig from 'tailwindcss/resolveConfig';

import rawTailwindConfig from '../tailwind.config.js';

const tailwindConfig = resolveConfig(rawTailwindConfig);

export { tailwindConfig };
